export interface ProjectCard {
  id: string
  name: string
  description: string
  logo: string | null
  appUrl: string | null
  trustedAuthorizedApp: boolean
}

const CARD_TTL_MS = 3600000

function tssUrl(): string {
  return (
    (typeof window !== 'undefined' && (window as any).__EMBARK_SERVICES__?.tssUrl) ||
    (typeof __EMBARK_TSS_URL__ !== 'undefined' && __EMBARK_TSS_URL__) ||
    '/oops-tss-api'
  )
}

const cache = new Map<string, { card: ProjectCard; fetchedAt: number }>()

export async function fetchProjectCard(projectId: string, now = Date.now()): Promise<ProjectCard | null> {
  const cached = cache.get(projectId)
  if (cached && now - cached.fetchedAt < CARD_TTL_MS) {
    return cached.card
  }

  try {
    const response = await fetch(`${tssUrl()}/api/tss/project/${encodeURIComponent(projectId)}`)
    if (!response.ok) {
      console.warn(`[iframe] Project card unavailable: ${response.status}`)
      return null
    }
    const card = (await response.json()) as ProjectCard
    cache.set(projectId, { card, fetchedAt: now })
    return card
  } catch (error) {
    console.error('[iframe] Project card request failed:', error)
    return null
  }
}

export function clearProjectCardCache(): void {
  cache.clear()
}
